module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter04"
    }
  }, [_c('a', {
    attrs: {
      "id": "page135"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page135"
    }
  }), _c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page135"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/text/9780062018465_Contents#chapter_04"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4.")])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062018465_Contents#chapter_04"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Supreme Products of the Age of Paper")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("I")])]), _vm._v("n the fifteenth century, at the height of the Italian Renaissance, it took twenty minutes to cross Florence on foot, fighting the crowds from the Ponte Vecchio to the Piazza di San Marco. Into this area, 95,000 people were crammed."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n274",
      "id": "n274",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" By today’s standards, Renaissance Florence was not a large city but even so it dwarfed Weimar, which perhaps fulfilled a similar role in the German renaissance.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("As one approached the city in the eighteenth century, one saw—standing out above the town’s 600 or 700 houses and their enclosing wall—the towers of a couple of churches and the ducal "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Schloss")]), _vm._v(" (fifteenth-century Florence had one cathedral and 110 churches)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n275",
      "id": "n275",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" There were two inns, the Erbprinz and the Elefant, three shops worth the name, and the streets were lit at night by 500 lanterns, though they were so expensive to maintain that the order to light them all was seldom given."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n276",
      "id": "n276",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" In 1786, the population was approaching 6,200, of which 2,000 were courtiers, bureaucrats, soldiers, or pensioners supported by taxation."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n277",
      "id": "n277",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" There was no trade, no tourism, and of course no factories. No wonder Madame de Staël felt Weimar to be “not a small town but a large château.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n278",
      "id": "n278",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Though it was small and unprepossessing physically (drainage was still very primitive), Weimar was a capital and it had a court. The original star—or “muse” (Goethe’s word)—of this court was Princess Anna "), _c('a', {
    attrs: {
      "id": "page136"
    }
  }, [_vm._v("Amalia of Brunswick, who had been married in 1756, while still a girl, to Ernst August Konstantin of Weimar, himself no more than eighteen. His small duchy was undistinguished, just one of 300 not dissimilar entities that stretched north to the Baltic and south to the Alps."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n279",
      "id": "n279",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" Weimar actually consisted of the combined duchies of Weimar and Eisenach, together with the former duchy of Jena and the bailiwick of Ilmenau. All four areas still maintained their separate tax systems.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("When Anna Amalia was married, she was not yet seventeen and her husband was under nineteen. Before he died, two years later, she had borne him one son, Karl August, with another on the way. She became Weimar’s regent during her son’s minority, and it was in the nineteen years before his accession that she changed the court and made later developments possible. Anna Amalia’s mother was a sister of Friedrich the Great and shared his views on the importance of art, literature, and theater."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n280",
      "id": "n280",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" On first meeting Anna Amalia, Schiller found her mind “very limited” but, in her efforts to keep up with rival courts nearby, she brought troupes of actors to Weimar, then musicians—and then “literati.” There would be four men of world stature who Anna Amalia helped bring to Weimar, of whom the first was Christoph Wieland (1733–1813).")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Appointed in 1772 as tutor to Karl August, then fifteen, Wieland was already one of Germany’s leading authors. He was of middle-class origin (his father was a pastor) and this association, of aristocrats and the middle class, unwittingly initiated a process that was to result in the partial fusion of two culture groups that would together provide what became known as “Weimar "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Klassik")]), _vm._v(".”"), _c('span', {
    staticClass: "footnoteRef"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Footnote_9",
      "id": "footnote9",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])])]), _vm._v(" Writers whose origins were lower down the social scale could earn a good living in either Paris or London, but in Germany social distinctions were still relatively rigid and amid all the other changes that Weimar brought about, the social change was as important as any.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Wieland’s early work, however, had earned him distinction among aristocrats, who counted. He had been a senator in his native town, Biberach in Württemberg, and a professor of philosophy at Erfurt (in Thuringia, central Germany); in his novel "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Der goldene Spiegel")]), _vm._v(" (The Golden Mirror; 1772), he had presented a political philosophy in the tradition of "), _c('a', {
    attrs: {
      "id": "page137"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Lettres persanes")]), _vm._v(" in that it criticized current affairs in Europe in a fanciful Oriental disguise (this was a practice that had begun in France). The novel emphasized education even for princes and especially the importance of history. But Wieland was also known for his novel "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Geschichte des Agathon")]), _vm._v(" (The Story of Agathon; 1766–67), a narrative of a young man who learns through personal experience that the excessively spiritual “enthusiasm” of his youth was folly. This was, in its way, a first sighting of rudimentary "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bildung")]), _vm._v(", and Wieland’s importance lies in his early grasp of this concept. The loss of faith experienced by many figures of the Enlightenment seems to have been more intense, sooner, in Germany than in France or England. Following the Earl of Shaftesbury (a profound influence in Germany), Wieland understood that, in the age of doubt, a man can still live for knowledge, art, and reflection—“the enlargement of his mind”—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and")]), _vm._v(" continue to fulfill traditional duties."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n281",
      "id": "n281",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Wieland took up his position in Weimar in September 1772 and immediately embarked on a project for a new literary monthly, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Der deutsche Merkur")]), _vm._v(", to accompany his primary responsibility, teaching Karl August. The first issue appeared in 1773 and was an immediate success. It continued publication for nigh on forty years and provided central Germany with a literary culture, in the process making Weimar, tiny as it was, the cultural capital. Wieland’s views overlapped with those of Friedrich the Great, who was still alive. He too thought Germans showed “a chronic uncertainty” in matters of taste, in marked contrast to somewhere like England, which had its “classics,” as we would say now. Wieland translated and published several Shakespeare plays in an attempt to show Germans what a “classic” from the post-classical world “looked like.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n282",
      "id": "n282",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Wieland was always convinced of the cultural importance of the theater. He pointed out that the stage had been a political institution in ancient Greece and it was, even now, in the enlightened, nonabsolute parts of Europe, a moral institution, “capable of exercising a wholesome influence on the thought and manners of an entire people.” Wieland, we must remember, was writing at a time when theater had still to contend with the opposition of the church. Even if others didn’t, Wieland recognized the theater as a venue where people could experience new ideas in a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("shared")]), _vm._v(" capacity. (This is one reason why the church—and other authori"), _c('a', {
    attrs: {
      "id": "page138"
    }
  }, [_vm._v("ties—objected.) The theater helped establish the actuality of “imagined communities,” as Benedict Anderson calls them; it helped spark the self-consciousness, and the self-confidence, of the middle classes.")])]), _c('a', {
    attrs: {
      "id": "page138"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page138"
    }
  }, [_vm._v("As for many others, for Wieland the German nation was “not really a nation, but an aggregate of many nations, like ancient Greece.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n283",
      "id": "n283",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(" He nevertheless thought that modern Germany had a character all its own, meaning he had sympathy with—and encouraged in his journal—the early Sturm und Drang poets then emerging. He also welcomed Goethe’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Götz")]), _vm._v(" as “the most beautiful and interesting of monstrosities, worth a hundred of our sentimental comedies.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n284",
      "id": "n284",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Here was the kind of new voice that, he felt, was needed.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("IRST")]), _vm._v(" G"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("REAT")]), _vm._v(" T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("RAGIC")]), _vm._v(" N"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OVEL")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Johann Wolfgang Goethe’s arrival in “the large chateau” stemmed from a chance meeting he had with Karl August, the son of Ernst August and Anna Amalia, in Frankfurt. Having chosen his bride, Luise of Hesse-Darmstadt, as he approached his eighteenth birthday, the prince regarded himself as now free to embark on his grand tour. This began, sensibly enough, with a visit to Karlsruhe, where Luise was living, but en route Karl August stopped at Frankfurt, where he was introduced to Goethe, already well known because of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Götz")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Werther")]), _vm._v(" (see Chapter 4). This unlikely pair got on surprisingly well together and met for a second time months later, this time in Karslruhe. The prince had overnighted there on his way back from Paris, while Goethe was bound for Switzerland. Paris had seduced Karl August. His tastes and his ambitions had grown more sophisticated and more cosmopolitan: Goethe was invited to Weimar."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n285",
      "id": "n285",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("The difference between Frankfurt and Weimar was larger than Goethe expected. In Frankfurt, a center of commerce, position was largely determined by financial criteria. At Weimar, in contrast, a basic distinction was made between those admissible at court ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("die Hoffähige")]), _vm._v(") and the rest. To be admitted at court, a title was necessary. And so was established a pattern that was to be repeated. Goethe was raised to the nobility, becoming Johann Wolfgang von Goethe, as happened with Schiller and Herder some years later."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n286",
      "id": "n286",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("At first, Goethe thought of himself as a visitor in Weimar, and this "), _c('a', {
    attrs: {
      "id": "page139"
    }
  }, [_vm._v("seems to be how others regarded him. Portraits show a man with large eyes, a slight crown on the bridge of his prominent nose, sensual lips. When he arrived in Weimar, Goethe was twenty-six to the prince’s eighteen—a large gap at that age and not the only important difference between them. Karl August might be a prince but Goethe was already much more famous. The previous year, he had produced "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Die Leiden des jungen Werthers")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Sorrows of Young Werther")]), _vm._v("), which, it is no exaggeration to say, had taken Europe by storm. Generally regarded as the first piece of “confessional” literature, this novel is of added interest because of its autobiographical element. The plot line of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Werther")]), _vm._v(" is closer to Goethe’s life than that between almost any other author and their works.")])]), _c('a', {
    attrs: {
      "id": "page139"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page139"
    }
  }, [_vm._v("In his early twenties, Goethe had spent time in Wetzlar, a small town forty miles north of Frankfurt. Ostensibly looking for a law practice, but not trying too hard, he spent a good deal of his time reading and writing poetry and falling in love with a young woman, Charlotte Buff, who was already engaged to someone else. It took Goethe a while to realize he could never win Charlotte, but then he moved on to Koblenz where, as was his way, he soon fell for someone else. He kept in touch with Lotte and her fiancé and through them learned the details of the suicide of a mutual friend, Karl Wilhelm Jerusalem. Jerusalem had fallen in love with a married women who hadn’t returned his feelings, whereupon the young man had borrowed some pistols (from none other than Charlotte’s fiancé) and shot himself. It therefore comes as no great surprise, as Michael Hulse says, that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Die Leiden des jungen Werthers")]), _vm._v(", published in Leipzig in 1774, was received in its time (and continues to be read) as partly autobiographical, partly biographical."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n287",
      "id": "n287",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(" Goethe, who took barely four weeks to write the book, later referred to it often as a “confession.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("The plot is simple and, says Nicholas Boyle, could only have been written because of Goethe’s religious emancipation."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n288",
      "id": "n288",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" Werther falls in love with Charlotte (Lotte), who is betrothed to another man. Although his love is requited by Lotte, it is doomed, and the unresponsiveness of the world and the couple’s sufferings eat away at him, so that he can see no alternative but to shoot himself with Lotte’s husband’s pistols. An “editor” then “gathers” his letters and publishes them with the occasional comment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Werther")]), _vm._v(" was almost immediately translated into every major European "), _c('a', {
    attrs: {
      "id": "page140"
    }
  }, [_vm._v("language, but the cult of the book went much wider. In Vienna there was a Werther fireworks display and in London there was Werther wallpaper. Meissen porcelain was designed, showing Werther scenes, and in Paris perfumières sold Eau de Werther. In Italy there was a Werther opera. Napoleon took the French translation with him on his Egyptian adventure in 1798 and, Hulse says, “when he met the author in 1808 he told him he had read the book seven times” (though he also added some criticisms)."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n289",
      "id": "n289",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Not everyone shared the rapture. There were those who thought the novel risked sparking a suicide epidemic, but the fear of a wave of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Liebestode")]), _vm._v(" seems to have been exaggerated. In Leipzig, nevertheless, the book was banned, as it was in Denmark. Elsewhere the book was derided, one critic suggesting sarcastically that “The smell of pancake is a more powerful reason for remaining in this world than all young Werther’s supposedly lofty conclusions are for quitting it.” Now that the dust has settled, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Werther")]), _vm._v(" has come to be regarded as “the first great tragic novel, a work of exhilarating style and insight.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n290",
      "id": "n290",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Despite Goethe’s fame, despite the turbulence his novel sparked across Europe, his friendship with Karl August was solid and genuine, and the writer joined in readily with those activities of the court that the younger man enjoyed—in particular, riding, shooting, and dancing. Bit by bit, however, Goethe’s very presence induced a change, and he began reading from his works in progress (most of what he wrote, he read aloud to friends), in particular his unfinished "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Faust")]), _vm._v(" (the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Urfaust")]), _vm._v(" as it is now called)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n291",
      "id": "n291",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Time was passing and after about a year, when it was becoming clear that Goethe’s “visit” was no such thing, Karl August moved to bring his friend closer still. Goethe was persuaded to join in another popular aspect of court life: amateur theatricals."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n292",
      "id": "n292",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" In this way he became the prince’s unofficial "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("maître des plaisirs")]), _vm._v(", and it was this appointment, informal to begin with, that shaped Goethe’s immediate future and, indeed, that of Weimar, as other—more onerous and more responsible—duties followed. More than one historian has observed that Karl August’s liking for Goethe owed rather more to his personal qualities than to his fame and skill as a writer. (Jürgen Habermas reminds us that Weimar was a special case, that most men of letters were little more than servants at that stage.) Goethe’s elevation at court was not universally welcomed (he was consid"), _c('a', {
    attrs: {
      "id": "page141"
    }
  }, [_vm._v("ered a “half-baked Voltairian know-all” by some), but the prince was an absolute monarch in an age of absolutism—and that was that."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n293",
      "id": "n293",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("The big change, from Goethe’s point of view, came in June 1776, when he was appointed a member of Karl August’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("conseil")]), _vm._v(", or Privy Council, which consisted of the duke and three advisers. Goethe was required to take an oath of allegiance, and that gave him the right to wear a distinctive laced coat."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n294",
      "id": "n294",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" Now his duties widened further. He took on the mining commission, the military commission, and was even made temporary head of the treasury. He was involved in road-building schemes and helped devise a new system of taxation. By all accounts, Goethe was a safe pair of hands, invariably aware of what was and was not practicable, and this transformed his popularity and made him respected. He was one of those responsible for the belief in Germany that “intellectuals need not live in ivory towers with their heads in the clouds.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n295",
      "id": "n295",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Goethe gained a lot from being in Weimar. Being forced to involve himself in mining, he found he needed to develop his interests in, and knowledge of, chemistry, botany, and mineralogy, and this moved him in the direction of science more generally. He was soon collecting plants and studying Carl Linnaeus’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Philosophia botanica")]), _vm._v(". Goethe exchanged a number of letters with Linnaeus and at the same time asked Karl August to send one of his assistants, J. C. W. Voigt, for training at the Freiberg Academy of Mining in Saxony, run by the foremost mineralogist of the day, Abraham Gottlob Werner. (Werner, who visited Goethe in late summer 1789, is considered in Chapter 7.) Later Goethe turned to anatomy, which he studied under Professor Loder in Jena and then passed on, in his own lectures, at the academy of drawing in Weimar."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n296",
      "id": "n296",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("At the same time that Goethe was pursuing his multifarious activities, he was also writing 1,800 letters to another Charlotte, Charlotte von Stein (the standard edition of Goethe’s works and letters runs to 138 volumes). She carefully hoarded these, “well aware that they were a unique record of an exceptional man’s inner life.” Their relationship is alluded to in Goethe’s two “Charlotte” plays, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Iphigenie auf Tauris")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Torquato Tasso")]), _vm._v(", where she is presented as the best in German womanhood, “a German Beatrice,” who aids the development of the immature poet and introduces him to “the pleasures and responsibilities of Humanity.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n297",
      "id": "n297",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Goethe never really lost the central interest he explored in his “Char"), _c('a', {
    attrs: {
      "id": "page142"
    }
  }, [_vm._v("lotte” period: his pursuit of “Bildung” (a word he used quite a bit). The inward pursuit of perfection is never again mentioned so directly as in his letters, but Goethe never lost his concern with the individual’s responsibility for his own inner development."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n298",
      "id": "n298",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("From 1781, by which time Goethe had been in Weimar for six years, he confided to Charlotte that he no longer felt able to address her as “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sie")]), _vm._v(",” and must use the more intimate “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("du")]), _vm._v(".” This brought about a sea change. As one critic put it, Goethe’s letters now became “prose poems of happy love with few parallels in any literature.” However, at the very moment their relationship should have matured, it didn’t—and the results were catastrophic. So far as we know, Charlotte, in her “strange ménage,” never made any move to leave her husband. When she did confess her love for Goethe, Goethe responded by leaving for Italy without even telling her that he was going, and by the time of his return from the warm south (Verona, Venice, Ferrara, Florence, Arezzo, Rome, Naples) the situation had deteriorated."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n299",
      "id": "n299",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" He had enjoyed his time (“this journey is really like a ripe apple falling from the tree”), but his views on love had been transformed (from a romantic view to a “pagan” view, it was said by some)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n300",
      "id": "n300",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" A sketch by his friend Tischbein, made in Rome, shows Goethe irritably pushing away “the second pillow”—i.e., Charlotte’s husband."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n301",
      "id": "n301",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" Also, Charlotte found it difficult to come to terms with the fact that Goethe had begun another affair, with Christiane Vulpius. (“I am only interested in the real thing, eager eyes and smacking kisses.”) Charlotte made a lame attempt to pillory Goethe in her play "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dido")]), _vm._v(", but it was not a success."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n302",
      "id": "n302",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" Their once-beautiful relationship had turned sour, and though they patched it up eventually, things were never the same again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Through it all, Goethe continued to write. A mixture of the realist and the romantic, not given overmuch to abstract speculation, Goethe subscribed to the view, explored in Chapter 2, that “God does not exercise influence on earth except through outstanding chosen men.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n303",
      "id": "n303",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" He knew he had it in him to be an outstanding man, “a great soul,” as he had described the character of Iphigenia."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n304",
      "id": "n304",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" He was also deeply affected by his discovery of the Greeks (thanks to Herder) and their idea that individuals—even geniuses—may contain within them unconscious creative urges that other people will find superlative, but those works still need to be realized, to be produced, and that task involves "), _c('a', {
    attrs: {
      "id": "page143"
    }
  }, [_vm._v("craft, perseverance, individual effort. The idea that life is a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("task")]), _vm._v(", was, of course, Pietist in origin, but the Greek influence seems to have induced Goethe to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("craft")]), _vm._v(" his next masterpiece, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wilhelm Meister")]), _vm._v(", and so successfully that even a sarcastic skeptic like James Joyce had to put him on a par with Shakespeare and Dante (Joyce’s trinity was “Shopkeeper,” “Daunty” and “Gouty”)."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n305",
      "id": "n305",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("In 1798, in a famous “Fragment” published in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Athenäum")]), _vm._v(", the periodical of the early German Romantics, Friedrich Schlegel identified the French Revolution, Johann Gottlieb Fichte’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wissenschaftslehre")]), _vm._v(" (1794), and Goethe’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wilhelm Meister")]), _vm._v(", as “the three greatest ‘tendencies’ of the age.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n306",
      "id": "n306",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" Schlegel was being deliberately provocative, but even in retrospect this takes some swallowing. Schlegel we shall encounter presently, where we can examine what, exactly, he meant by his choice. Fichte we shall also come to later, where we can explore the meaning and significance of his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wissenschaftslehre")]), _vm._v(". But whatever Schlegel meant, when he put "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wilhelm Meister")]), _vm._v(" in this exalted company, he was doing us a favor of sorts. There is no question that, as a novel, as a story, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wilhelm Meister")]), _vm._v(" was not only a masterpiece: it was also the first of a genre, a particularly "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("German")]), _vm._v(" genre, which became known as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bildungsroman")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("A "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bildungsroman")]), _vm._v(" is typically a novel of ideas. William Bruford, professor of German at Cambridge after World War II, devoted an entire book to the German Bildungsroman, in which he shows that Goethe’s model was followed by many others in Germany. Here is his definition of the form: “[W]e are shown the development of an intelligent and open-minded young man in a complex modern society without generally accepted values…We see him acquiring a point of view but above all a ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Weltanschauung")]), _vm._v(",’ a lay religion or general philosophy of life…In a Bildungsroman the centre of interest is not the hero’s character or adventures or accomplishments in themselves, but the visible link between his successive experiences and awareness of worthy models and his gradual achievement of a fully rounded personality and well tested philosophy of life.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n307",
      "id": "n307",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" It is a journey inward as much as forward.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("In Goethe’s story, Wilhelm is born into a bourgeois family and, as his adventures go by, he comes to understand the limitations of his original existence as a “carefully brought-up son” in the middle classes. He lives for a time among theater people, engrossed by the charm of their sponta"), _c('a', {
    attrs: {
      "id": "page144"
    }
  }, [_vm._v("neity; elsewhere, he is introduced to “the lesser talents” of being a gentleman, talents that are mainly negative—a gentleman “does not show his feelings,” he understates everything, he never hurries; later, Goethe has Wilhelm wounded in an attack by armed bandits. Through it all, he meets a raft of women—older women, capricious women, women from a higher social class. He observes which men are successful with the opposite sex and what their secret is."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n308",
      "id": "n308",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(" He immerses himself in the works of Shakespeare, discovering a rich world he never knew existed. Eventually, he marries a woman from a large family and—part of the point of the book—begins to achieve a measure of control over, and understanding of, his life.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Goethe had a serious aim. He had told Caroline Herder that he had lost his belief in divine powers in the summer of 1788 and the purpose of life, when there is no god, he is saying in the book, is to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("become")]), _vm._v(", to become much more than one was."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n309",
      "id": "n309",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" “The ultimate meaning of our humanity is that we develop that higher human being within ourselves, which emerges if we continually strengthen our truly human powers, and subjugate the inhumane.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n310",
      "id": "n310",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" Some non-Germans have found it too much. Henry Sidgwick, the Cambridge-based late nineteenth-century philosopher, is said to have reprimanded a German visitor who observed there was no word in English equivalent to “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gelehrt")]), _vm._v("” (cultivated). “Oh yes there is, we call it a prig.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Goethe’s most famous masterpiece, however, and this is true both inside and outside Germany, is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Faust.")]), _vm._v(" This, “the most characteristic product of his genius,” was written at intervals over sixty years, in four bursts of creative energy."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n311",
      "id": "n311",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" It was by no means a new story, being a well-known medieval legend, made into a play by Christopher Marlowe, though Goethe wasn’t aware of Marlowe’s work until he had written more than half of his own version."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n312",
      "id": "n312",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("The legend may even be grounded in fact. There was a Georg Faust alive at the turn of the sixteenth century who wandered through central Europe claiming to possess recondite forms of knowledge which gave him special healing powers. After his death he gradually acquired a slight change of name and an academic title, as Dr. Johannes Faustus, a professor at Wittenberg. In his lectures, he was alleged to “conjure up at will” personages from classical Greece, and he was notorious too for allegedly "), _c('a', {
    attrs: {
      "id": "page145"
    }
  }, [_vm._v("playing tricks on both the pope and the emperor. There was a price to pay for this license and in his case it was said that he had agreed to “a term” of twenty-four years with the devil, whereupon his body would be “torn to pieces by demons.” Faust was often featured in puppet plays, which is where Goethe may have encountered the story as a child."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n313",
      "id": "n313",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("According to the legend, Faust becomes disillusioned with the many forms of secret knowledge he has tried out, and the devil, Mephistopheles, makes a wager with God that he can tempt Faust into his world. Mephistopheles sees to it that, in the course of his researches into magic and alchemy, he himself is conjured up by Faust, whereupon he broaches his famous proposal: Mephistopheles will introduce Faust to all the pleasures the world has to offer, the only proviso being that if, at any point, Faust should wish to sample any delight “for longer than the moment it is on offer,” his life will end and he will belong to the devil. Bored, unfulfilled, Faust accepts.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("In Part One the main theme is Faust’s seduction and subsequent desertion of Margareta (Gretchen), a beautiful girl he meets outside a church. In Part Two—written decades later—Faust, waking from a long sleep during which he has forgotten Margareta, now becomes enamored of Helen of Troy (this is a magical world, after all)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n314",
      "id": "n314",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("No brief summary can do justice to the attractions of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Faust")]), _vm._v("—its language, its wit, its pithy insights into human nature, not to mention Mephistopheles’ brand of cynicism, “an original and highly effective, not to say sympathetic conception of the devil.” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Faust")]), _vm._v(" and Mephistopheles have even been compared to the Book of Job as a meditation on the nature of evil (in Job too there is a compact with God). Goethe also took a leaf out of Shakespeare’s book: like the Bard’s plays, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Faust")]), _vm._v(" resists Christianization. God is not the petty-minded jealous God of the Israelites but a more generous—and yes, even witty—deity.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Goethe began writing the book in the early 1770s, later destroying the manuscript—or so he thought. The very existence of this early manuscript, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Urfaust")]), _vm._v(", was unknown until 1887, when it was discovered sixty-five years after his death. Apparently it was copied by a young lady at the Weimar court, and her manuscript was never destroyed. Goethe’s description of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Faust")]), _vm._v(" as “fragments of a great confession” should not be forgotten. He himself wrote:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page146"
    }
  }), _c('div', {
    staticClass: "extract",
    staticStyle: {
      "margin-left": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page146"
    }
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-1.3em",
      "margin-left": "1.3em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("…Our play is rather like the life of Man:")])]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-1.3em",
      "margin-left": "1.3em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("We make a start, we make an end—")])])]), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-1.3em",
      "margin-left": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page146"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("But make a whole of it? Well, do so if you can.")]), _c('span', {
    staticClass: "footnoteRef"
  })]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Footnote_10",
      "id": "footnote10",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Was he saying that was the best way to treat life? Absorb its disparate parts, “Kiss the moment,” as Schiller was to put it, but don’t try too hard to impose too much unity."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n315",
      "id": "n315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" For Faust, it is not the search for unity that matters, it is movement, creation, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("activity")]), _vm._v(", over and above and before mere enjoyment. Mere contemplation of beauty is empty. In this Goethe is a pre-Romantic.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Nicholas Boyle, in his biography of Goethe and his age, argues that “more must be known, or at any rate there must be more to know, about Goethe than any other human being…Nearly 3,000 drawings by him survive, as do the villa he built, the palace he rebuilt, and the park he first laid out. He amassed very substantial private collections of mineralogical specimens, [and] incised gems…After he moved to Weimar the daily chronicle of his doings, now being put together for the first time in seven large volumes by Robert Steiger, is practically continuous, especially once he began to keep a regular diary in 1796. Accounts of conversations with him…run to some 4,000 printed pages, over 12,000 letters from him are extant, and about 20,000 letters addressed to him.” As for his writing, Boyle concludes, “As the age of paper passes, so he comes to seem its supreme product.”")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("A N"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EW")]), _vm._v(" M"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EANING FOR")]), _vm._v(" “N"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ATION” AND")]), _vm._v(" “C"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ULTURE”")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Johann Gottfried Herder (1744–1803) was five years older than Goethe and, like Winckelmann, like Heyne and like Fichte, a poor boy who had risen out of his class through sheer ability, along with a chance meeting with a Russian army surgeon who, on his way back from the Seven Years’ War, was quartered in 1761–62 in the east Prussian town where Herder lived. Conceiving a liking for Herder, the surgeon proposed to take him to Königsberg, where the young man could study medicine at the university. "), _c('a', {
    attrs: {
      "id": "page147"
    }
  }, [_vm._v("In return, Herder would translate a medical treatise into Latin. Herder accepted the proposal but, once in Königsberg, he found medicine uncongenial and switched to theology.")])]), _c('a', {
    attrs: {
      "id": "page147"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page147"
    }
  }, [_vm._v("This was a second fortuitous turn, for it brought Herder to study under Kant, and it was Kant who introduced Herder to Rousseau and Hume, who were to have such an effect on his thinking. Ordained in 1767, Herder found his way to Paris where he was received by some of the leading figures of the Enlightenment, including Denis Diderot and d’Alembert. But he was still chronically poor and so accepted a position as the tutor and traveling companion to the son of the Prince of Lübeck and Holstein. This was the third fortuitous turn. En route to his appointment, he stopped off in Hamburg, where he met Lessing and, soon afterward, in Strasbourg with the prince, he met Goethe (this was July 1770). Realizing at once that Herder was less than content with his position, Goethe prevailed upon Karl August to invite his friend to Weimar as head of the clergy in the state. Herder kept the position for the rest of his life and seems to have been content—his children used to go looking for painted eggs in Goethe’s garden."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n316",
      "id": "n316",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Herder is not nearly as famous as Goethe, but in many ways his ideas and influence were more immediate, more direct, and more widespread."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n317",
      "id": "n317",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" “Like Max Weber over a century later, Herder was preoccupied with the problem of social relations in a world that increasingly came to resemble for him a vast machine in which men were like cogs, whose lives were governed by the inexorable operations of mechanical bureaucracies.” He addressed this predicament in two books, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ideen zur Philosophie der Geschichte der Menschheit")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reflections on the Philosophy of the History of Mankind")]), _vm._v("; 1784–91; four volumes), and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Auch eine Philosophie der Geschichte zur Bildung der Menschheit")]), _vm._v(" (This Too a Philosophy of History for the Formation of Humanity), published in 1774. Here, his main concern was, as he put it, to discover the rules of the morals of association. What invisible hand is there that shapes spontaneous political association?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Hume and Kant aside, the main influence on Herder was Leibniz. Herder looked upon Leibniz as “the greatest man Germany ever possessed” and saw himself as part of that tradition—Leibniz, Thomasius, Lessing, and Herder. These men had conceived the idea of “becoming,” when the universe was held to be an “organic” entity and in which Leib"), _c('a', {
    attrs: {
      "id": "page148"
    }
  }, [_vm._v("niz’s understanding of history as “a continuous process of development, energised by human striving,” profoundly affected Herder’s historical thinking. For Lessing, moral striving, “moral becoming,” as he put it, was the central concern of all education, of all cultivation. “Man could only be truly himself by consciously realising his individuality.” Herder refined this eloquently. He insisted that, for him, humanity was not a state into which man was born “but rather a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("task")]), _vm._v(" demanding fulfilment by conscious development.” This idea of Bildung as a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("task")]), _vm._v(" dominated the philosophy of the majority of subsequent German writers, from Goethe, as we have seen, to Humboldt and Fichte."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n318",
      "id": "n318",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")]), _vm._v(" Again, one can imagine Henry Sidgwick snorting, as he turns in his grave, but there is a unity here in German thought: Bildung as a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("task")]), _vm._v(" comes from the recognizably Pietist lineage and looks forward to Weber’s concept of the Protestant work ethic. It was also subversive, because it placed a premium on the intrinsic worth of individual judgment, and accordingly rejected (external) authority as the fundamental source in religious and moral matters.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Herder also thought that Rousseau had in effect put the cart before the horse. A “social contract” was a misnomer for him because, as he saw it, the state of society "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" man’s state of nature. Man is born into a family whether he likes it or not. But man isn’t just a social animal—he is also a political animal, for life in society needs order, organization."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n319",
      "id": "n319",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" This is where Herder joined forces with Bodmer, Gottsched, Wolf, and Humboldt: the underlying “sustaining force” of all this organization, he said, is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("language")]), _vm._v(". As Locke had done, Herder dismissed the divine origin of language. There was, he said, no stage or epoch in prehistory when language had been invented, nor had it developed from animal sounds. We cannot think without words, he insisted, therefore language must have emerged when consciousness developed."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n320",
      "id": "n320",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" Which meant that, for Herder, language reflects the history and psychology of a distinctive social heritage, and this was by far his most influential argument—language identifies a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Volk")]), _vm._v(" or nationality, and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("this")]), _vm._v(", the historico-psychological entity of the common language, is for him “the most natural and organic basis for political organisation…Without its own language a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Volk")]), _vm._v(" is an absurdity ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Unding")]), _vm._v("). For neither blood and soil, nor conquest and political fiat can engender that unique consciousness which alone sustains the existence and continuity of a social entity.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n321",
      "id": "n321",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" Language, as well as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("unifying")]), _vm._v(" a community, also "), _c('a', {
    attrs: {
      "id": "page149"
    }
  }, [_vm._v("identifies that community’s consciousness of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("difference")]), _vm._v(" from those speaking other tongues. “A "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Volk")]), _vm._v(", on this theory, is a natural division of the human race, endowed with its own language, which it must preserve as its most distinctive and sacred possession.” Language was given a potency it had never had before.")])]), _c('a', {
    attrs: {
      "id": "page149"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page149"
    }
  }, [_vm._v("It was this close association, between language and self-consciousness, that brought about such a drastic change in the most commonly accepted idea of a “nation.” “A nation no longer simply meant a group of citizens united under a common political sovereign.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n322",
      "id": "n322",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")]), _vm._v(" It was now regarded as a separate "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("natural")]), _vm._v(" entity whose claim to political recognition “rested on the possession of a common language.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n323",
      "id": "n323",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Herder went further. For him, in any "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Volk")]), _vm._v(" grouping, there were two elements. There was first the bourgeoisie ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("das Volk der Bürger")]), _vm._v("), and second a minority of intellectuals ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("das Volk der Gelehrsamkeit")]), _vm._v("). The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bürger")]), _vm._v(" were not only the most numerous but also the most useful (he called them “the salt of the earth”), and he sharply distinguished them from what was in fact a third group, the “rabble” ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pöbel")]), _vm._v("). What distinguished the Bürger, and what was the chief reason for their social inferiority and political impotence (until that point), he said, was their lack of education. The fact that this was so, he insisted, could not be put down to innate ability, or lack of it. “It was rather the harvest of persistent and wilful neglect.” He therefore came out boldly and blamed the ruling aristocracy for this state of affairs. “That those as yet unborn should be destined to rule over others not yet born, simply by virtue of their blood, seemed to Herder the most unintelligible of propositions.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n324",
      "id": "n324",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Herder, therefore, did not expect the people at the top of the tree ever to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("do")]), _vm._v(" anything to jeopardize their position. Instead, he published his argument in the hope that he might inspire the emergence of popular leaders, “men of the people,” who would spread the message of education (Bildung). It was the job of the state, he felt, to help each individual to develop and fulfill his or her propensities. “To fail to make use of man’s divine and noble gifts, to allow these to rust and thus to give rise to bitterness and frustration, is not only an act of treason against humanity, but also the greatest harm which a state can inflict upon itself.” This shows Herder’s very modern grasp of the links between economics, politics, and education or, more particularly, Bildung. For Herder (as for Humboldt), the "), _c('a', {
    attrs: {
      "id": "page150"
    }
  }, [_vm._v("development of the self, the humanization of the self, will not only make people better individuals but also better—and more willing—members of the community. Reciprocity is for Herder the whole point of human association."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n325",
      "id": "n325",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("This fit Herder’s overall aim, to give culture—as well as nation—a new meaning. With his deeply historical view of human affairs, and his Leibnizian inheritance—that change was of the essence—he formed the view that whatever the “collective consciousness” of a Volk was at any particular time, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" its culture."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n326",
      "id": "n326",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" This was wholly at odds with the prevailing Enlightenment tradition where culture was aligned with civilization and understood as a reflection of intellectual sophistication. It was thus Herder who was responsible for our modern usage of such phrases and concepts as “political culture,” “peasant culture,” and so on. At root, Herder suspected that culture was not simply the result of experience alone but owed something to a genetic component (though of course the modern understanding of genetics did not then exist)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n327",
      "id": "n327",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" This combination of genetics and experience helped in turn to generate the main ideas that shape history, he said, and, at any particular stage, a Zeitgeist, a “spirit of the time,” can emerge. Herder is credited with coining this term."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n328",
      "id": "n328",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Herder’s view was essentially an updated and secularized version of Francke’s Pietist theology: the Creation could be improved upon. It could be developed, evolved, helped to become more than it had been, all via the process of Bildung, which elevated knowledge as the highest good, the all-important foundation for human association. A belief in the perfectibility of man was a sine qua non, he insisted, if we are to accept a role for the human will in the shaping of history."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n329",
      "id": "n329",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" For Herder, recognizing that there "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" an inborn drive to perfection is part of man’s developing self-consciousness, part of his evolution, in a doubt-ridden, pre-Darwinian world.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("As Aristotle—and Leibniz—had before him, Herder sought to integrate the inner development of man with his outer, social arrangements."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n330",
      "id": "n330",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" In his lifetime (he died in 1803) the advent of the industrial revolution was not yet well enough advanced to have an impact in Germany (or anywhere for that matter), but the disjunction between the inner world and the outer, social world, would come to dominate nineteenth-century thought above everything else, as the concept of “alienation,” preoccupy"), _c('a', {
    attrs: {
      "id": "page151"
    }
  }, [_vm._v("ing everyone from Hegel to Karl Marx to Freud. Herder was the first to outline these lineaments in a language we recognize today.")])]), _c('a', {
    attrs: {
      "id": "page151"
    }
  }, [_c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("N"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EW")]), _vm._v(" F"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ORMS OF")]), _vm._v(" N"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OBILITY")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Johann Christoph Friedrich Schiller (1759–1805) was born in Marbach am Neckar. His father was a military surgeon, and Friedrich was given a medical training in addition to a good general education. The medical faculty at the military academy at Marbach was excellent, and Schiller proved to be an exceptional pupil: his thesis—on physiology—was approved for publication by none other than the duke himself. (In small states dukes and princes sometimes took a personal interest in their clever charges.) Schiller’s thesis was accepted only on the third attempt—but even so he broke new ground, first bursting on the world as a scientist. In his 1780 thesis, titled "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("On the Connection between the Animal and Spiritual Nature of Man")]), _vm._v(", Schiller not only advanced the view that the mind regulates the body, and vice versa, but he also argued that “harmony” between the two was not the “default” position, as we would say today, but rather that human physiology “is a tension-filled process,” a precarious balance that needs to be nurtured and maintained. Within this view is the implication that such things as diet, physical circumstances, and personal relationships have an effect on “mental health” and not just one’s relationship with God.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page151"
    }
  }, [_vm._v("Medicine, important as it was for Schiller, was not his first love. At school, the Karlsschule, he was introduced to Kant, particularly his writings on aesthetics, and to Shakespeare (Schiller became known, later in life, as “the German Shakespeare”). Together with Goethe, Schiller’s works comprise the main elements in the “canon” now known as “Weimar classicism.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n331",
      "id": "n331",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("As with Herder, Schiller’s early adult life was unsettled—he moved around, from Mannheim to Dresden to Leipzig. His first play, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Die Räuber")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Robbers")]), _vm._v("), was written in 1781, printed at his own expense, and performed the following year in Mannheim. The central character is the leader in a band of robbers, but the chief theme is that leader’s rejection of the values of his father. The play is essentially about the nature of liberty—"), _c('a', {
    attrs: {
      "id": "page152"
    }
  }, [_vm._v("to what extent is it inner freedom, and to what extent outer social/political freedom?—such a focus being new and daring (at least in Germany with its many absolutist states)."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n332",
      "id": "n332",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Among all Schiller’s plays, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kabale und Liebe")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Intrigue and Love")]), _vm._v(", 1784), has always been the most popular, surviving everywhere as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Luisa Miller")]), _vm._v(" in Giuseppe Verdi’s opera of that name. The play is an attack on the cruelty and oppressiveness of absolutism. Ferdinand and Luise, the two main characters, try to escape their class and the bourgeois and aristocratic conventions that imprison them. They fail. Ferdinand is prepared to risk all but not Luise, who (correctly) anticipates there will be reprisals against her father. Schiller’s point is that, under absolutism, characters are unable to become autonomous."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n333",
      "id": "n333",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Schiller’s first “overwhelming” masterpiece came next, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Don Carlos")]), _vm._v(" being welcomed by a critic as “one of the world’s greatest pieces of literature.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n334",
      "id": "n334",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" Here the theme of conflict between father and son is continued. Set in sixteenth-century Spain during the reign of Phillip II, Don Carlos, heir to the throne, is in love with his childhood friend, Elisabeth of Valois, to whom he was once betrothed but who is now his stepmother following her marriage to Phillip. Carlos is determined to resolve his passion for Elisabeth, and to do so enlists the aid of his friend, Rodrigo, Marquis of Posa, whose task is to engineer a meeting between the two would-be lovers. But Posa, charged with arguing the case of the oppressed people of Flanders, sees in this an opportunity for Carlos to foment a full-scale rebellion against his father’s tyrannical regime, which extends not just to his political subordinates but to his family as well. More than this, Schiller’s deeper design is to show that weakness is as much the basis of tyranny as is strength. Phillip may have raw political power but he is lonely, jealous, and miserable."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n335",
      "id": "n335",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("In 1787, the year "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Don Carlos")]), _vm._v(" was performed, Schiller visited Weimar, hoping to meet Goethe. At the time, Goethe was in Italy, but Schiller did succeed in meeting both Herder and Wieland and spent time in the company of Duchess Anna Amalia. Two years later, on Goethe’s recommendation, he was invited to become professor of history at the University of Jena.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Although Goethe was responsible for Schiller’s presence in Jena, and in Weimar, we now know that, to begin with, each kept his distance. Rivalry, "), _c('a', {
    attrs: {
      "id": "page153"
    }
  }, [_vm._v("or respect, probably played their part though Schiller certainly thought that Goethe was too self-important. But, early in 1794, Schiller began looking for people to contribute to his periodical, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Die Horen")]), _vm._v(" (The Horae, 1795–97), and Goethe was, not unnaturally, among those asked."), _c('span', {
    staticClass: "footnoteRef"
  })]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Footnote_11",
      "id": "footnote11",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])]), _vm._v(" This got them talking, so that it was natural for them to leave together after a meeting of the Society for Natural Science in Jena. During that conversation, Schiller attacked—but politely, respectfully—Goethe’s notion of a primal plant, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Urpflanze")]), _vm._v(", from which all others are derived. Schiller followed this up with a letter in which he contrasted his own critical-analytical (“sentimental”) approach to reality, with Goethe’s more organic (“naïve”) belief in the simplicity of nature and in natural genius (whose intuitions were implicitly above criticism). Schiller’s argument owed something to his medical training, something to Kant, and something to the German intellectual traditions introduced in Chapter 2, and it won Goethe’s respect: from then on they were firm friends. Although very different, their letters confirm that they subsequently each had a hand in the writing of the other’s works, notably "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Faust")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wallenstein")]), _vm._v("."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n336",
      "id": "n336",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Schiller, probably more than Goethe, was much affected by news of the Revolution and subsequent Reign of Terror in France (1793–94). The execution of well over a hundred members of the ancien régime sickened him, as it sickened many other Germans, but he did not follow the path of many fellow intellectuals in Germany, who turned away from the massacres to the inner life. Schiller was not given to Pietistic inwardness or, for that matter, political nihilism."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n337",
      "id": "n337",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" For him, the main threat facing the world was barbarism, which he thought had always been with us, as common in the ancient world as it was in his own time. These reflections led to one of his major theoretical works, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Über die ästhetische Erziehung des Menschen")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("On the Aesthetic Education of Man")]), _vm._v("), in which Schiller offered an alternative to the predicament he saw around him. For Schiller, education was the best—the only—way forward, but it was to be education of a special kind: it was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("aesthetic")]), _vm._v(" culture that produced the “healthiest” relationship between reason and emotion. For him, art and literature, images and words, offered the best hope of showing how the imagination and the "), _c('a', {
    attrs: {
      "id": "page154"
    }
  }, [_vm._v("understanding can work collaboratively together, one limiting the other to help us avoid extremes, which Schiller saw as the main problem underpinning barbarity. For Schiller, Bildung of the individual through knowledge of aesthetic culture had an ennobling effect on character."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n338",
      "id": "n338",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Though Schiller was not conspicuously Pietist, like Herder he shared Francke’s view that the Creation can be improved upon. Schiller seems to have thought that our minds are divided into two: the instrument of understanding and the imagination. The purpose of imagination, creativity, is to expand understanding and self-awareness. That being so, he distinguished three epochs in the evolution of civilization—the natural state, when the individual is subject to the forces of nature; the moral state, when man has identified the rules of nature and uses those rules as the basis of living together; and the aesthetic state, when he is free of these forces. In the first epoch, raw force prevails; the “ethical” state is governed by law; and in the “aesthetic” state individuals are free to treat each other as in a play—that is, people can choose their own roles."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n339",
      "id": "n339",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" In aesthetic society, beauty “acquaints us with our full potential.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("This sounds impossibly idealistic, but in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Über naïve und sentimentalische Dichtung")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("On Naïve and Sentimental Poetry")]), _vm._v(") Schiller carried his argument still further and produced a thesis that some, at least, have seen as “one of the founding documents of literary modernity.” His argument here is that the naïve poet is preoccupied with nature, whereas the sentimental poet is preoccupied with art and that something is lost in the latter process."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n340",
      "id": "n340",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" For Schiller, human beings in antiquity were closer to nature, and therefore were “more human” than they are now, primarily because they were less corrupted by culture (here is one origin of the German distinction between culture and civilization). For him the Greeks were more noble than we are, precisely because they disclaim “any desire to be more than human.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n341",
      "id": "n341",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" Poetry therefore ennobles us only insofar as it keeps us close to our true nature. This aspiration to nobility, to self-improvement, to Bildung, on the part of the middle classes was for him (as it was for others in the eighteenth century, such as Edward Gibbon, Hume, and Adam Smith), “the most important element in modern history.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n342",
      "id": "n342",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Having made his mark as a medical scientist, a playwright, a theorist about poetry, and a philosopher of aesthetics, in 1792 Schiller turned historian and published his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Geschichte des Dreissigjährigen Krieges")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("History of "), _c('a', {
    attrs: {
      "id": "page155"
    }
  }, [_vm._v("the Thirty Years War")])]), _c('a', {
    attrs: {
      "id": "page155"
    }
  }, [_vm._v("), in which he painted some unforgettable pictures of the main protagonists, most notably Gustavus Adolphus and Wallenstein."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n343",
      "id": "n343",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")]), _vm._v(" Work on this book seems to have given him new ideas about the dramatic realm because, four years later, he began his three great late dramas, which were to join the canon of the Weimar classics. These were "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wallenstein")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maria Stuart")]), _vm._v(", and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wilhelm Tell")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Wallenstein")]), _vm._v(", completed in 1799, when Schiller was forty, shows him gathering strength as a tragedian. Lessing, in his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hamburgische Dramaturgie")]), _vm._v(", had argued in favor of bourgeois tragedy, on the grounds that “the concept of the state is far too abstract to appeal to our senses.” Schiller, in complete contrast, took a leaf out of the Greek book, realizing that the stage is essentially an aesthetic public space, making it perhaps the only location where we can overcome the alienation between the state and the individual.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Count Albrecht Wallenstein, a (real) Bohemian Protestant who has become a Catholic, serves Emperor Ferdinand, becoming the Thirty Years’ War’s most famous commander. Wallenstein is as ferocious as any of those who have committed atrocities during the conflict but, in 1643, he sees a chance of concluding a peace with the (Protestant) Swedes, despite the fact that such a peace is against the will of the emperor. Wallenstein’s initiative is not carried out only from the highest motives, of course—he has been as corrupted as the next man—and he himself is accused of treason and murdered on the emperor’s orders, and the peace negotiations founder. But Schiller is asking here whether motives "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("need")]), _vm._v(" to be pure for peace, suggesting that war is so corrupting that even a peace achieved for less than pure motives is still a noble aim.")]), _vm._v(" "), _c('div', {
    staticClass: "extract",
    staticStyle: {
      "margin-left": "1.3em"
    }
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-1.3em",
      "margin-left": "1.3em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Every hand is raised")])]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-1.3em",
      "margin-left": "1.3em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Against the other. Each one has his side.")])]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-1.3em",
      "margin-left": "1.3em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("No one can judge. When will it end and who")])]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-1.3em",
      "margin-left": "1.3em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Untie the knot that endlessly adds to")])]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-1.3em",
      "margin-left": "1.3em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Itself.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Wallenstein seizes the moment, but the moment backfires. The experience of revolution, Schiller is saying, teaches us that any attempt to destroy an existing state based on pure reason (i.e., ignoring other political "), _c('a', {
    attrs: {
      "id": "page156"
    }
  }, [_vm._v("realities and the existing power structure and the emotions they engender) produces only catastrophe and chaos."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n344",
      "id": "n344",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")]), _vm._v(" The plot, and indeed the character of Wallenstein, are much closer to Schiller’s own time than to the Thirty Years’ War, which is the setting. Wallenstein himself is closer to Napoleon than to any personages in the earlier conflict, and contemporary audiences recognized this. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wallenstein")]), _vm._v(" is important because it is an early sighting of that (predominantly German) view that reason is not the be-all and end-all of forces shaping the human condition, a tradition that was to consume Marx, Arthur Schopenhauer, and Richard Wagner, and culminate in Nietzsche, Freud, and Martin Heidegger.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Schiller has given us some of the most magnificent women of the stage. In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Intrigue and Love")]), _vm._v(", the skirmishes between Luise and Lady Milford, who occupies a much higher social standing, are a remarkable rhetorical duel. In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maria Stuart")]), _vm._v(" the rivalry between Elizabeth and Mary is, if anything, an even higher level of combat. The play dramatizes an encounter between Queen Elizabeth I of England and Mary Queen of Scots in her last days, when she was held captive in the Castle of Fotheringhay. In real life Elizabeth and Mary never met, but the play imagines the meeting and, at the outset, the two queens are “sisters”—they are not, to begin with, complete opposites. As the play develops, however, Elizabeth’s behavior is increasingly governed by her senses, the physical here-and-now, whereas Mary moves to the spiritual/intellectual plane. Although both women are equally formidable, equally noble, equally isolated, Mary’s “state of sublimity” creates a growing—ultimately unbridgeable—gap between the two. Despite her political pre-eminence, Elizabeth, Schiller is saying, is essentially a prisoner of her office, which prevents her from being herself. Mary, though politically emaciated and physically shackled, is still morally free. These two female monarchs, so similar in so many outward ways, have very different inner natures—and that is what counts."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n345",
      "id": "n345",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" Do Elizabeth’s actions against Mary stem entirely from the exigencies of the political situation, or is it more personal and, if so, in what way? Can Elizabeth ever know? Can "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("we")]), _vm._v(" ever know? Is such self-knowledge possible?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("For many people, the characters and predicaments of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Don Carlos")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wallenstein")]), _vm._v(", and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maria Stuart")]), _vm._v(" are even more overwhelming than those of Goethe’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Faust")]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Werther")]), _vm._v(". Giuseppe Verdi drew on Schiller for four operas "), _c('a', {
    attrs: {
      "id": "page157"
    }
  }, [_vm._v("("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Luisa Miller")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Joan of Arc")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I Masnadieri")]), _vm._v(", and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Don Carlos")]), _vm._v("), Beethoven used “An die Freude” (Ode to Joy) in his choral symphony, and Schiller’s poems inspired Johannes Brahms, Franz Liszt, Felix Mendelssohn, Franz Schubert, Robert Schumann, Richard Strauss, and Pyotr Ilich Tchaikovsky. More Schiller has been set to music than has Shakespeare.")])]), _c('a', {
    attrs: {
      "id": "page157"
    }
  }), _c('a', {
    attrs: {
      "id": "page158"
    }
  })]), _c('a', {
    attrs: {
      "id": "page158"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page158"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbb157ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062018465_Chapter_4.vue
// module id = 87
// module chunks = 0